<template>
	<div
		class="section-grid-row grid grid-cols-4 *:w-full *:max-w-none *:px-1 *:pb-1"
	>
		<FormKit
			type="autocomplete"
			name="birthCountry"
			:label="t('plan.birthCountry')"
			:placeholder="
				t('plan.placeholders.select', {
					placeholderLabel: t('person.country'),
				})
			"
			:options="countryOptions"
			clear-search-on-open
		/>

		<FormKit
			type="textarea"
			auto-height
			name="birthCity"
			:label="t('plan.birthCity')"
		/>

		<FormKit
			v-if="model.birthCountry === 'US'"
			type="autocomplete"
			name="birthState"
			:label="t('plan.birthState')"
			:options="stateOptions"
			:placeholder="
				t('plan.placeholders.select', {
					placeholderLabel: t('person.state'),
				})
			"
			clear-search-on-open
		/>

		<FormKit
			v-else
			type="text"
			name="birthState"
			:label="t('plan.birthStateProvinceRegion')"
			:placeholder="t('plan.placeholders.enterStateProvinceRegion')"
		/>

		<FormKit
			type="textarea"
			auto-height
			name="birthCounty"
			:label="t('plan.birthCounty')"
		/>
	</div>
</template>

<script setup lang="ts">
import { countryOptions } from '@/data/countryOptions'
import { stateOptions } from '@/data/stateOptions'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

defineProps<{ model: Record<string, any> }>()

const { t } = usePresentationLocale()
</script>
